import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgSpinKitModule } from 'ng-spin-kit';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

@NgModule({
  imports: [CommonModule, NgSpinKitModule, SweetAlert2Module],

  exports: [NgSpinKitModule, SweetAlert2Module]
})
export class CommonSharedModule { }
